import React from "react"

import { NetworkAdUnit } from "./styles"

const InlineAd = ({ article, element, hideTitle }) => {
  const { nsfw } = article

  return (
    <NetworkAdUnit
      isInlineAd
      className="inline-ad"
      unitName="Article_Inline"
      articleId={article.id}
      nsfw={nsfw}
      hideTitle={hideTitle}
      position={`inline-${element?.index || 1}`}
    />
  )
}

export default InlineAd
